import { render, staticRenderFns } from "./TagTouchedEntities.vue?vue&type=template&id=3354d5f9&"
import script from "./TagTouchedEntities.vue?vue&type=script&lang=js&"
export * from "./TagTouchedEntities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports